import { useIntl } from 'react-intl'

import { useLang } from '../../_metronic/i18n/Metronici18n'

interface Props {
  className?: string,
  withVersion?: boolean
}

const Footer : React.FC<Props> = ({className, withVersion=false}) => {
  
  const intl = useIntl()

  const lang = useLang()

  return (
    <>
      <div className={`d-flex ${className && className} ${withVersion ? 'flex-column flex-center' : 'flex-center'}`}>
        {withVersion && (
        <div className="text-muted fw-semibold">
          {intl.formatMessage({id: 'general.beta_version_1_0'})}
        </div>
        )}
        <div className="text-muted fw-semibold text-center">
          {intl.formatMessage({id: 'general.copy_rights'}, {'year': new Date().getFullYear()})}
        </div>
      </div>
    </>
  )
}


export {Footer}
